export default __webpack_public_path__ + "static/media/case-sensitive.6cc8c44b.svg";